import palette from '../palette';

export const Timer = {
  progressBackground: {
    step1: '#29a329',
    step2: '#c2940a',
    step3: '#da500b',
    step4: '#a32929',
    finished: palette.bluegrey400,
  },
};
